// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"Mn-z","badgeLink":"Nn-z","category":"On-z"};